import React from "react";

const Java_Prime_Check = () => {
  return (
    <div>
      <h1>Java Prime Check</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Prime Check in Java.</p>
    </div>
  );
};

export default Java_Prime_Check;
